import React from 'react';
import { X, Send } from 'lucide-react';
import { MicIcon, SoundWaveIcon } from '../Icons';
import { BottomSheet } from '../BottomSheet';
import {
  SheetContent,
  CloseButton,
  TextArea,
  CheckboxRow,
  Checkbox,
  CheckboxLabel,
  ButtonRow,
  VoiceButton,
  SendButton,
} from './ReplyBottomSheet.styled';

interface ReplyBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  messageText: string;
  onMessageTextChange: (text: string) => void;
  hideFromPatient: boolean;
  onHideFromPatientChange: (checked: boolean) => void;
  onVoiceInput: () => void;
  onSend: () => void;
  isSending: boolean;
  isRecording: boolean;
  isProcessing?: boolean;
  showHideFromPatient?: boolean;
}

export const ReplyBottomSheet: React.FC<ReplyBottomSheetProps> = ({
  isOpen,
  onClose,
  messageText,
  onMessageTextChange,
  hideFromPatient,
  onHideFromPatientChange,
  onVoiceInput,
  onSend,
  isSending,
  isRecording,
  isProcessing = false,
  showHideFromPatient = true,
}) => {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} maxHeight="auto">
      <SheetContent>
        <CloseButton type="button" onClick={onClose}>
          <X size={24} />
          閉じる
        </CloseButton>
        <TextArea
          value={messageText}
          onChange={(e) => onMessageTextChange(e.target.value)}
          placeholder="メッセージを書く"
          autoFocus
        />
        {showHideFromPatient && (
          <CheckboxRow>
            <Checkbox
              type="checkbox"
              checked={hideFromPatient}
              onChange={(e) => onHideFromPatientChange(e.target.checked)}
            />
            <CheckboxLabel>非表示設定(利用者本人に共有しない)</CheckboxLabel>
          </CheckboxRow>
        )}
        <ButtonRow>
          <VoiceButton
            type="button"
            onClick={onVoiceInput}
            $isRecording={isRecording || isProcessing}
            disabled={isProcessing}
          >
            {isRecording ? <SoundWaveIcon /> : <MicIcon />}
            {isRecording ? '聞き取り中...' : isProcessing ? '変換中...' : '音声入力'}
          </VoiceButton>
          <SendButton
            type="button"
            $hidden={isRecording || isProcessing}
            onClick={onSend}
            disabled={!messageText.trim() || isSending}
          >
            <Send size={20} />
            送信する
          </SendButton>
        </ButtonRow>
      </SheetContent>
    </BottomSheet>
  );
};

export default ReplyBottomSheet;
